module.exports = __webpack_public_path__ + "media/images/home/price_sp-3ccbf0ba2a673f657bc48697b62df6fa.png";